var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrentLocation = function SvgCurrentLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M12 4.5a7.5 7.5 0 1 0 .002 15A7.5 7.5 0 0 0 12 4.5Zm0 4a3.5 3.5 0 1 1-3.5 3.513l.004-.201a3.5 3.5 0 0 1 3.328-3.308zm-.5 11.998-.444-.05a8.504 8.504 0 0 1-7.504-7.503l-.05-.444h-.446L2 12.5a.5.5 0 0 1 0-1h1.502l.05-.444a8.505 8.505 0 0 1 7.504-7.504l.444-.05V2a.5.5 0 0 1 1 0v1.502l.444.05a8.504 8.504 0 0 1 7.505 7.504l.05.444H22a.5.5 0 0 1 0 1h-1.502l-.05.444a8.504 8.504 0 0 1-7.503 7.504l-.444.05v.446L12.5 22a.5.5 0 0 1-1 0z"
  })));
};
export default SvgCurrentLocation;